// 抓包任务表单的草稿与换算（决策 D93，docs/04 第 10 节）：目标二选一，时长 1 到 60 分钟、条数 1 到 10 万。
import type { CaptureInput } from "@/app/captures";
import type { Errors } from "@/app/useDraft";

export type CaptureTarget = "account" | "channel";

export interface CaptureDraft { target: CaptureTarget; account_id: string; channel_id: string; minutes: string; max_packets: string; note: string }

export function captureDraft(): CaptureDraft {
  return { target: "account", account_id: "", channel_id: "", minutes: "10", max_packets: "10000", note: "" };
}

/** 校验并换算：只提交所选目标的 ID。 */
export function captureInput(d: CaptureDraft): { body?: CaptureInput; errors: Errors<CaptureDraft> } {
  const errors: Errors<CaptureDraft> = {};
  const inRange = (v: string, lo: number, hi: number) => /^\d+$/.test(v) && Number(v) >= lo && Number(v) <= hi;
  if (d.target === "account" && !d.account_id) errors.account_id = "选择客户账号。";
  if (d.target === "channel" && !d.channel_id) errors.channel_id = "选择供应商通道。";
  if (!inRange(d.minutes, 1, 60)) errors.minutes = "1 到 60 的整数。";
  if (!inRange(d.max_packets, 1, 100_000)) errors.max_packets = "1 到 100000 的整数。";
  if (Object.keys(errors).length) return { errors };
  return { errors, body: {
    account_id: d.target === "account" ? Number(d.account_id) : null, channel_id: d.target === "channel" ? Number(d.channel_id) : null,
    minutes: Number(d.minutes), max_packets: Number(d.max_packets), note: d.note.trim() || null,
  } };
}
